import { APPLIED_SINGLE_FILTER } from './actionTypes'

export default (selectedFilterObject, selectedFilterName) => ({
  type: APPLIED_SINGLE_FILTER,
  payload: {
    selectedFilterObject,
    selectedFilterName
  }
})